import type { Bounds } from 'pixi.js';
import { Text } from 'pixi.js';
import { Signal } from 'typed-signals';
import { getLocalizedText } from '@softgames/localization';
import type { Popup } from '../../../popups/Popup';
import { RateUsPopupLayout } from '../../../../layouts/popups/RateUsPopupLayout';
import { soundManager } from '../../../app/SoundManager';

export class RateUsPopup implements Popup {
  public readonly onConfirmClicked = new Signal();

  public readonly onCancelClicked = new Signal();

  private readonly layout = new RateUsPopupLayout();

  public readonly root = this.layout.root;

  public readonly initialBounds: Bounds;

  constructor() {
    this.initialBounds = this.root.getLocalBounds();

    this.hideCloseButton();
    this.initTexts();
    this.initButtons();
  }

  private hideCloseButton(): void {
    // Hide close button - only two decision buttons are needed
    this.layout.closeButton.visible = false;
  }

  private initTexts(): void {
    const { titleText, messageText, confirmButton, cancelButton } = this.layout;

    // Set localized texts from translation files
    titleText.text = getLocalizedText('Enjoying?');
    messageText.text = getLocalizedText('Your feedback helps us make the game even better.');

    // Get text elements from button containers and ensure single-line display
    const confirmButtonText = confirmButton.children.find((child) => child instanceof Text);
    if (confirmButtonText instanceof Text) {
      confirmButtonText.text = getLocalizedText('Love it!');
      // Ensure single-line text (no word wrap)
      confirmButtonText.style.wordWrap = false;
    }

    const cancelButtonText = cancelButton.children.find((child) => child instanceof Text);
    if (cancelButtonText instanceof Text) {
      cancelButtonText.text = getLocalizedText('Not really');
      // Ensure single-line text (no word wrap)
      cancelButtonText.style.wordWrap = false;
    }
  }

  private initButtons(): void {
    const { confirmButton, cancelButton } = this.layout;

    confirmButton.on('pointertap', () => {
      soundManager.play('UI_Button_Click');
      this.onConfirmClicked.emit();
    });

    cancelButton.on('pointertap', () => {
      soundManager.play('UI_Button_Click');
      this.onCancelClicked.emit();
    });
  }
}

